import classnames from 'classnames'
import { RichText, RichTextProps } from '../../molecules/RichText'
import Image, { ImageProps } from '../image/Image'

import styles from './tabsCarousel.module.scss'

export interface TabsCarouselPanelProps {
  imageProps: ImageProps
  contentRichTextContent?: RichTextProps
  className?: string
}

export const TabsCarouselPanel = ({ className = '', ...props }: TabsCarouselPanelProps) => {
  const wraperClasses = classnames(styles.tabsCarouselPanel, className)
  return (
    <div className={wraperClasses}>
      {props.contentRichTextContent && (
        <RichText
          {...props.contentRichTextContent}
          className={classnames(styles.content, props.contentRichTextContent.className)}
        />
      )}
      <Image
        alt={props.imageProps.alt}
        {...props.imageProps}
        className={classnames(styles.slideImage, props.imageProps.className)}
      />
    </div>
  )
}

export default TabsCarouselPanel
